export enum VisitorsError {
  INVALID_EMAIL = 'error-invalid-email',
  DUPLICATE_EMAIL = 'error-duplicate-email',
  DUPLICATE_ORGANIZER_EMAIL = 'error-duplicate-organizer-email',
}
